module.exports = __webpack_public_path__ + "img/Gudalur TNFD Logo Sq.64e1fa8e.jpg";